export const dateFilterParams = {
  // provide comparator function
  comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
    const dateAsString = cellValue;

    if (dateAsString == null) {
      return 0;
    }

    // cellValue is IsoString
    // We create a Date object for comparison against the filter date, removing the time from the iso string
    const dateParts = dateAsString.split('T')[0].split('-');
    const year = Number(dateParts[0]);
    const month = Number(dateParts[1]) - 1;
    const day = Number(dateParts[2]);
    const cellDate = new Date(year, month, day);

    // Now that both parameters are Date objects, we can compare
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
};
